import { Item } from "./Item";

export interface Spacer extends Item {
  type: "Spacer";
}

export function isSpacer(obj: object): obj is Spacer {
  return typeof obj === "object" && "type" in obj && obj.type === "Spacer";
}
